import axios from "axios";
import React, { useEffect, useState } from "react";
import VideoCard from "./VideoCard";
import { Grid } from "@mui/material";
import "../Videos.css";
import Header from "./Header";
import Genre from "./Genre";

function Videos() {
  const [videos, setVideos] = useState([]);
  const [SearchText, setSearchText] = useState("");
  const [debounceTimer, setDebounceTimer] = useState(0);
  const [activecategory, setActiveCategory] = useState("All");


  // I DID SOMETHING HERE TO MAKE ALL AGE GRP DEFAULT ACTIVE
  const [ageActivecategory, setAgeActiveCategory] = useState("All");
  const [genre, setGenre] = useState({
    All: true,
    Education: false,
    Sports: false,
    Comedy: false,
    lifeStyle: false,
  });
  const [age, setAge] = useState({
    All: true,
  });
  // TILL HERE


  const performApiCall = async (SearchTerm) => {
    // console.log(SearchTerm)
    let url = `https://79b7d29c-2a32-48a8-85f8-7296793908d1.mock.pstmn.io/vi/videos`;
    if (SearchTerm !== "") {
      url = `${url}?title=${SearchTerm}`;
    }
    const response = await axios.get(url);
    const videosReceived = response.data.videos;
    console.log("Api Call Made");
    console.log(response.data.videos);
    setVideos(videosReceived);
  };

  const handleInput = (e) => {
    console.log(e.target.value);
    setSearchText(e.target.value);
  };

  useEffect(() => {
    performApiCall();
  }, []);

  useEffect(() => {
    if (SearchText !== "") {
      if (debounceTimer !== 0) {
        clearTimeout(debounceTimer);
      }
  
      const newTimer = setTimeout(() => {
        performApiCall(SearchText);
      }, 800);
  
      setDebounceTimer(newTimer);
    }
  }, [SearchText]);

  const getFilteredVideos = (e, category) => {
    let id = e.target.id;
    let value;
    if (genre[id] === true) {
      genre[id] = false;
      setGenre(genre);
    } else {
      genre[id] = true;
      setGenre(genre);
    }
    console.log(category);
    console.log(value);
    let newArr = [];
    for (const key in genre) {
      newArr.push(key.value);
    }
    axios
      .get(
        `https://79b7d29c-2a32-48a8-85f8-7296793908d1.mock.pstmn.io/vi/videos?genres=${category}`
      )
      .then((response) => {
        // Handle the response data here
        console.log(category);
        console.log(response.data);
        // Update the videos state variable with the fetched data
        setVideos(response.data.videos);
        console.log(response.data.videos);
        // Update the active category state variable
        setActiveCategory(value);
      })
      .catch((error) => {
        // Handle the error here
        console.log(error);
      });
  };

  // I DID SOMETHING HERE TO MAKE ALL AGE GRP DEFAULT ACTIVE
  const getFilteredRatedVideos = (e, category) => {
    let id = e.target.id;
    let value;
    if (age[id] === true) {
      age[id] = false;
      setAge(age);
    } else {
      age[id] = true;
      setAge(age);
    }
    console.log(category);
    console.log(value);
    let newArr = [];
    for (const key in age) {
      newArr.push(key.value);
    }
    axios
      .get(
        `https://79b7d29c-2a32-48a8-85f8-7296793908d1.mock.pstmn.io/vi/videos?contentRating=${category}`
      )
      .then((response) => {
        // Handle the response data here
        console.log(category);
        console.log(response.data);
        // Update the videos state variable with the fetched data
        setVideos(response.data.videos);
        console.log(response.data.videos);
        // Update the active category state variable
        setAgeActiveCategory(value);
      })
      .catch((error) => {
        // Handle the error here
        console.log(error);
      });
  };
// TILL HERE


  const fetchContent = async () => {
    try {
      const response = await axios.get(
        `https://79b7d29c-2a32-48a8-85f8-7296793908d1.mock.pstmn.io/vi/videos?contentRating=12%2B`
      );
      const data = response.data.videos;
      setVideos(data);
      console.log(data);
    } catch (error) {
      console.log(error)
    }
  };

  const fetchRdVideos = async () => {
    try {
      const response = await axios.get(
        `https://79b7d29c-2a32-48a8-85f8-7296793908d1.mock.pstmn.io/vi/videos?sortBy=releaseDate`
      );
      const data = response.data.videos;
      setVideos(data);
      console.log(data);
    } catch (error) {
      console.log(error)
    }
  }

  const fetchVcVideos = async () => {
    try {
      const response = await axios.get(
        `https://79b7d29c-2a32-48a8-85f8-7296793908d1.mock.pstmn.io/vi/videos?sortBy=viewCount`
      );
      const data = response.data.videos;
      setVideos(data);
      console.log(data);
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <>
      <Header handleInput={handleInput} searchVal={SearchText} />
      <Genre
        getAccToVc={fetchVcVideos}
        getAccToRD={fetchRdVideos}
        getContent={fetchContent}
        genre={genre}
        setGenre={setGenre}
        getVideos={getFilteredVideos}
        // I DID SOMETHING HERE TO MAKE ALL AGE GRP DEFAULT ACTIVE
        getRatedVideos={getFilteredRatedVideos}
        age={age}
        // TILL HERE
      />
      <Grid style={{height: "100%"}} className="VideosGrid" container spacing={2}>
        {videos.map((video) => {
          const {
            videoLink,
            contentRating,
            _id,
            previewImage,
            genre,
            title,
            releaseDate,
            viewCount,
          } = video;
          return (
            <Grid item lg={3} md={4} sm={6} xs={12} key={_id}>
              <VideoCard
                videoLink={videoLink}
                key={_id}
                imgLink={previewImage}
                genre={genre}
                title={title}
                releaseDate={releaseDate}
                contentRating={contentRating}
                viewCount={viewCount}
                id={_id}
              />
            </Grid>
          );
        })}
      </Grid>
    </>
  );
}

export default Videos;
